export default "__VITE_ASSET__C868qkfh__"